import {FC, SVGProps} from 'react';
import {twMerge} from 'tailwind-merge';

import LogoIcon from '@/assets/icons/logo.svg?react';

type AppLogoProps = SVGProps<SVGSVGElement>;

const AppLogo: FC<AppLogoProps> = ({className, ...props}) => (
  <LogoIcon
    {...props}
    className={twMerge('h-auto w-[76px] text-primary sm:w-[107px]', className)}
  />
);

export default AppLogo;
